import Link from "@/components/atoms/link";
import Typography from "@/components/atoms/typography";
import useTranslation from "@/providers/I18n/hooks/useTranslation";
import React from "react";

const CheckoutBackToCart = () => {
    const { translate } = useTranslation();

    return (
        <div className="w-fit sm:block hidden">
            <Link link={"/cart"}>
                <div className="flex gap-2.5 items-center w-fit">
                    <span className="">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 19L8 12L15 5" stroke="#090909" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </span>
                    <div className="">
                        <Typography className='!text-[17.94px] !leading-[21.71px] !text-black'>
                        Back To Cart
                        </Typography>
                    </div>
                </div>
            </Link>
        </div>

    )
}

export default CheckoutBackToCart